module.exports = __webpack_public_path__ + "media/images/multi-arrow-ee4afc800c5e9adda391191d21c95ea6.svg";